import type { QueryClient, QueryKey } from '@tanstack/react-query';

/**
 * Call after a live (or optimistic) change to a cached query. A reload already on its way was answered before the
 * change: when it lands it would put the old state back (e.g. voting "not open yet" until the next reload), so it
 * starts again and its answer includes the change.
 */
export function restartReload(qc: QueryClient, queryKey: QueryKey) {
    if (qc.isFetching({ queryKey }) > 0) void qc.invalidateQueries({ queryKey }, { cancelRefetch: true });
}

/** Change a cached query, if loaded, then restart a reload that predates the change (see restartReload). */
export function patchQuery<T>(qc: QueryClient, queryKey: QueryKey, fn: (old: T) => T) {
    qc.setQueryData<T>(queryKey, old => (old === undefined ? old : fn(old)));
    restartReload(qc, queryKey);
}
